export const FILTERED_VIEW_PARAM_NAME = 'filteredViewId' as const
export const FILTERED_VIEW_NAME_MAX_LEN = 100 as const // equals to backend value

export const FILTERED_VIEW_TYPE_PROP_NAME = 'type' as const
